import { z } from "zod";

import { eventTypeAppCardZod } from "../eventTypeAppCardZod";

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    templateId: z.string().optional(),
    templateName: z.string().optional(),
    roleName: z.string().optional(),
    requireSignatureBeforeMeeting: z.boolean().optional(),
  })
);

// Admin sets client_id (Integration Key) + client_secret (Secret Key) in Admin > Apps.
// These are Schedly's DocuSign connected application credentials — the same for all users.
// Per-user access_token/account_id is stored in Credential after each user's OAuth.
export const appKeysSchema = z.object({
  client_id: z.string().min(1),
  client_secret: z.string().min(1),
});
